import React from "react";

import { Link } from "react-router-dom";

const BreadCrumb = ({ crumbs }) => {
    const renderCrumbs = () => {
        return (
            crumbs &&
            crumbs.map((crumb, index) => {
                if (!crumb.hide) {
                    const crumbValue = crumb.path ? (
                        <Link to={crumb.path}>{crumb.element()}</Link>
                    ) : (
                        crumb.element()
                    );
                    return (
                        <li
                            className={`breadcrumb-item ${
                                index === crumbs.length - 1 ? "active" : ""
                            }`}
                            key={index}
                            aria-current={
                                index === crumbs.length - 1 ? "page" : ""
                            }
                        >
                            {crumbValue}
                        </li>
                    );
                }
            })
        );
    };
    return (
        <>
            <nav>
                <ol className="breadcrumb shadow">{renderCrumbs()}</ol>
            </nav>
        </>
    );
};

export default BreadCrumb;
